'use client';

import Script from 'next/script';

export const ChiliPiperScript = () => (
  // biome-ignore lint/correctness/useUniqueElementIds: Next.js Script requires a static id for deduplication
  <Script
    id="chilipiper-concierge"
    src="https://blinq.chilipiper.com/concierge-js/cjs/concierge.js"
    crossOrigin="anonymous"
    strategy="afterInteractive"
  />
);
